<template>
  <v-container v-if="$can('browse-service-stats')">
    <div
      class="headline mb-6"
    >
      Stats
    </div>
    <v-row>
      <!--<editor-fold desc="Filters column">-->
      <v-col
        sm="3"
        class="hidden-xs-only"
      >
        <div style="position: sticky; top: 20px">
          <v-subheader class="justify-space-between pr-0">
            Filters
            <v-btn
              v-if="isFiltered"
              text
              color="red"
              @click="clearFilters"
            >
              <v-icon
                small
                left
              >
                close
              </v-icon>
              Clear
            </v-btn>
          </v-subheader>

          <assignee-modal-select
            v-model="filtersDirty.assigned_to"
            label="Assigned to"
            solo
            hide-details
            clearable
            chips
            class="mb-2"
            type="staff"
            :dialog-visible.sync="assigneeModalSelectVisible"
            @submit="assigneeModalSelectVisible = false"
          />

          <v-btn-toggle
            v-model="filtersDirty.dateFilterSwitch"
            class="mb-2"
            mandatory
            borderless
          >
            <v-btn value="date">
              Period
            </v-btn>

            <v-btn
              value="today"
            >
              Only today
            </v-btn>
          </v-btn-toggle>
          <div v-if="filtersDirty.dateFilterSwitch === 'date'">
            <v-menu
              v-model="filtersDateFinishedAtFromMenu"
              :close-on-content-click="false"
              max-width="290"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  :value="filtersDirty.from ? $moment(filtersDirty.from).format('DD.MM.YYYY') : ''"
                  solo
                  label="From"
                  placeholder="From"
                  clearable
                  hide-details
                  readonly
                  class="mb-2"
                  v-on="on"
                  @click:clear="filtersDirty.from = null"
                />
              </template>
              <v-date-picker
                v-model="filtersDirty.from"
                @change="filtersDateFinishedAtFromMenu = false"
              />
            </v-menu>
            <v-menu
              v-model="filtersDateFinishedAtToMenu"
              :close-on-content-click="false"
              max-width="290"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  :value="filtersDirty.to ? $moment(filtersDirty.to).format('DD.MM.YYYY') : ''"
                  solo
                  label="To"
                  placeholder="To"
                  clearable
                  hide-details
                  readonly
                  v-on="on"
                  @click:clear="filtersDirty.to = null"
                />
              </template>
              <v-date-picker
                v-model="filtersDirty.to"
                @change="filtersDateFinishedAtToMenu = false"
              />
            </v-menu>
          </div>
        </div>
      </v-col>
      <!--</editor-fold>-->
      <!--<editor-fold desc="Data table column">-->
      <v-col
        sm="13"
        cols="16"
      >
        <v-row class="mb-3">
          <!--          <v-col>-->
          <!--            <v-card-->
          <!--              class="elevation-10 radius-10 fill-height"-->
          <!--              style="border-top: 5px solid #607d8b"-->
          <!--            >-->
          <!--              <v-card-text class="pa-6 grey&#45;&#45;text text&#45;&#45;darken-2">-->
          <!--                <div class="display-1 mb-1">-->
          <!--                  {{ staffData.total_counts.total_hours_assigned.toFixed(1) }}-->
          <!--                </div>-->
          <!--                <div class="subtitle-1 font-weight-regular grey&#45;&#45;text">-->
          <!--                  Total Hours Assigned-->
          <!--                </div>-->
          <!--              </v-card-text>-->
          <!--            </v-card>-->
          <!--          </v-col>-->
          <v-col>
            <v-card
              class="elevation-10 radius-10 fill-height"
              style="border-top: 5px solid #607d8b"
            >
              <v-card-text class="pa-6 grey--text text--darken-2">
                <div class="display-1 mb-1">
                  {{ staffData.total_counts.total_hours_finished.toLocaleString('hr', { maximumFractionDigits: 0 }) }}
                </div>
                <div class="subtitle-1 font-weight-regular grey--text">
                  Total Hours Spent
                </div>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col>
            <v-card
              class="elevation-10 radius-10 fill-height"
              style="border-top: 5px solid #607d8b"
            >
              <v-card-text class="pa-6 grey--text text--darken-2">
                <div class="display-1 mb-1">
                  {{ staffData.total_counts.total_tasks_assigned.toLocaleString('hr') }}
                </div>
                <div class="subtitle-1 font-weight-regular grey--text">
                  Total Tasks Scheduled
                </div>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col>
            <v-card
              class="elevation-10 radius-10 fill-height"
              style="border-top: 5px solid #607d8b"
            >
              <v-card-text class="pa-6 grey--text text--darken-2">
                <div class="display-1 mb-1">
                  {{ staffData.total_counts.total_tasks_finished.toLocaleString('hr') }}
                  <span class="grey--text headline font-weight-regular">
                    {{ staffData.total_counts.total_tasks_finished / staffData.total_counts.total_tasks_assigned | percentage }}
                  </span>
                </div>
                <div class="subtitle-1 font-weight-regular grey--text">
                  Total Tasks Finished
                </div>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
        <!--<editor-fold desc="Pagination header">-->
        <pagination
          :from="staffData.meta.from"
          :to="staffData.meta.to"
          :total="staffData.meta.total"
          :last-page="staffData.meta.last_page"
          :page.sync="pagination.page"
          class="mb-1 align-end"
        />
        <!--</editor-fold>-->
        <v-data-table
          :headers="tableHeaders"
          :items="staffData.data"
          :loading="staffData.loading"
          :page.sync="pagination.page"
          :sort-by.sync="sorting.sortBy"
          :sort-desc.sync="sorting.desc"
          :server-items-length="staffData.meta.total"
          must-sort
          hide-default-footer
          class="elevation-5"
        >
          <template v-slot:item="{ item: staff }">
            <staff-stats-table-row
              :staff="staff"
            />
          </template>
          <template slot="no-data">
            <!--<editor-fold desc="Filtered">-->
            <div
              v-if="isFiltered"
              class="text-center py-4"
            >
              <div>
                There are no results for your search.
              </div>
              <div
                class="mt-2"
              >
                <v-btn
                  small
                  text
                  @click="clearFilters()"
                >
                  <v-icon left>
                    clear
                  </v-icon>
                  Clear Filters
                </v-btn>
              </div>
            </div>
            <!--</editor-fold>-->
            <!--<editor-fold desc="NoData">-->
            <div
              v-else
              class="text-center py-4"
            >
              There are no stats at the moment.
            </div>
            <!--</editor-fold>-->
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import serviceCurrentLocationMixin from '@/mixins/serviceCurrentLocationMixin'
import filterableMixin from '@/mixins/filterableMixin'
import AssigneeModalSelect from '@/components/service/helpers/AssigneeModalSelect'
import paginationMixin from '@/mixins/paginationMixin'
import StaffStatsTableRow from '@/components/service/stats/StaffStatsTableRow'
import Staff from '@/models/Staff'

export default {
    name: 'StatsIndex',
    components: { StaffStatsTableRow, AssigneeModalSelect },
    mixins: [paginationMixin, filterableMixin, serviceCurrentLocationMixin],
    data() {
      return {
        staffData: {
          data: [],
          meta: {},
          loading: false,
          total_counts: {
            total_hours_assigned: 0,
            total_hours_finished: 0,
            total_tasks_assigned: 0,
            total_tasks_finished: 0
          }
        },
        filtersDirty: {
          assigned_to: [],
          from: this.$moment().startOf('month').format('YYYY-MM-DD'),
          to: this.$moment().endOf('month').format('YYYY-MM-DD'),
          dateFilterSwitch: 'today'
        },
        filtersClean: {
          assigned_to: [],
          from: null,
          to: null,
          dateFilterSwitch: 'today'
        },
        sorting: {
          sortBy: 'name',
          desc: false
        },
        filtersDateFinishedAtFromMenu: false,
        filtersDateFinishedAtToMenu: false,
        assigneeModalSelectVisible: false
      }
    },
    computed: {
      tableHeaders() {
        return [
          { text: 'Name', value: 'name', sortable: true },
          { text: 'Hours Spent', value: 'total_hours_spent', width: '1px', sortable: true },
          { text: 'Tasks Worked On', value: 'total_assigned_tasks_count', width: '1px', sortable: true },
          { text: 'Tasks Finished', value: 'total_finished_tasks_count', width: '1px', sortable: true }
        ]
      }
    },
    created() {
      this.fetchStats()
    },
    methods: {
      onPaginationUpdate() {
        this.fetchStats()
      },
      onCurrentLocationUpdate() {
        this.fetchStats()
      },
      onFiltersUpdate() {
        this.fetchStats()
      },
      async fetchStats() {
        this.staffData.loading = true

        let queryParams = {
          ...this.paginationQueryParams,
          ...this.currentLocationQueryParams,
          from: this.filtersDirty.dateFilterSwitch === 'today' ? undefined : this.filtersDirty.from,
          to: this.filtersDirty.dateFilterSwitch === 'today' ? undefined : this.filtersDirty.to,
          assigned_to: this.filtersDirty.assigned_to ? this.filtersDirty.assigned_to.id : undefined
        }

        try {
          this.staffData = await Staff.api.fetchStats(queryParams)
        } catch (e) {
          await this.$store.dispatch('alert', {
            'text': 'Something went wrong',
            'color': 'error'
          })
          throw e
        } finally {
          this.staffData.loading = false
        }
      }
    }
  }
</script>
